var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function assertCanWriteControl(control) {
    if (!isControlWriteable(control))
        throw new Error('expected writeable control');
}
export function assertIsRangedControl(control) {
    if (!isRangedControl(control))
        throw new Error('expected RangedControl');
}
export function canCheckHasControl(control, controlInfo, power) {
    return !(controlInfo.powerOffRestrictions.includes('hasControl') && !power);
}
export function isControlReadable(control) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return control.get !== undefined;
}
export function isControlWriteable(control) {
    return 'set' in control && control.set !== undefined;
}
export function isRangedControl(control) {
    return 'range' in control;
}
export class ControlInfo {
    constructor() {
        this._checkedHasControl = false;
        this._hasControl = false;
        this._isStateless = false;
        this._isToggle = false;
        this._powerOffRestrictions = [];
    }
    get checkedHasControl() {
        return this._checkedHasControl;
    }
    get hasControl() {
        return this._hasControl;
    }
    get isStateless() {
        return this._isStateless;
    }
    get isToggle() {
        return this._isToggle;
    }
    get powerOffRestrictions() {
        return this._powerOffRestrictions;
    }
    static create(control, config, power, log, overrideIsStateless) {
        return __awaiter(this, void 0, void 0, function* () {
            const controlInfo = new ControlInfo();
            if (control === undefined)
                return controlInfo;
            controlInfo.updateSimpleProperties(control, config, overrideIsStateless);
            if (!('hasControl' in control) || control.hasControl === undefined) {
                controlInfo._hasControl = true;
                controlInfo._checkedHasControl = true;
            }
            else {
                const canCheckHasControl = !controlInfo.powerOffRestrictions.includes('hasControl') || power;
                if (canCheckHasControl) {
                    try {
                        controlInfo._hasControl = yield control.hasControl(config);
                    }
                    catch (error) {
                        log.error(error.message);
                        controlInfo._hasControl = false;
                    }
                    controlInfo._checkedHasControl = true;
                }
            }
            return controlInfo;
        });
    }
    static createCustom(values) {
        const controlInfo = new ControlInfo();
        if ((values === null || values === void 0 ? void 0 : values.hasControl) !== undefined)
            controlInfo._hasControl = values.hasControl;
        if ((values === null || values === void 0 ? void 0 : values.isStateless) !== undefined)
            controlInfo._isStateless = values.isStateless;
        if ((values === null || values === void 0 ? void 0 : values.isToggle) !== undefined)
            controlInfo._isToggle = values.isToggle;
        if ((values === null || values === void 0 ? void 0 : values.powerOffRestrictions) !== undefined) {
            controlInfo._powerOffRestrictions = values.powerOffRestrictions;
        }
        return controlInfo;
    }
    static createOffline(control, config, overrideIsStateless) {
        const controlInfo = new ControlInfo();
        if (control === undefined)
            return controlInfo;
        controlInfo._hasControl = true;
        controlInfo.updateSimpleProperties(control, config, overrideIsStateless);
        return controlInfo;
    }
    canGet(power) {
        return !this._isStateless && (!this._powerOffRestrictions.includes('get') || power);
    }
    canSet(power) {
        return !this._powerOffRestrictions.includes('set') || power;
    }
    updateSimpleProperties(control, config, overrideIsStateless) {
        if (overrideIsStateless !== undefined) {
            this._isStateless = overrideIsStateless;
        }
        else if ('isStateless' in control && control.isStateless !== undefined) {
            if (typeof control.isStateless === 'function') {
                this._isStateless = control.isStateless(config);
            }
            else {
                this._isStateless = control.isStateless;
            }
        }
        else {
            this._isStateless = !('get' in control);
        }
        if ('isToggle' in control && control.isToggle !== undefined) {
            if (typeof control.isToggle === 'function') {
                this._isToggle = control.isToggle(config);
            }
            else {
                this._isToggle = control.isToggle;
            }
        }
        else {
            this._isToggle = false;
        }
        if ('powerOffRestrictions' in control && control.powerOffRestrictions !== undefined) {
            if (typeof control.powerOffRestrictions === 'function') {
                this._powerOffRestrictions = control.powerOffRestrictions(config);
            }
            else {
                this._powerOffRestrictions = control.powerOffRestrictions;
            }
        }
        else {
            this._powerOffRestrictions = [];
        }
    }
}
